module.exports = new __parcel__URL__("list-preview.9c8441b2.svg").toString();